import React from 'react'

import {
  Accordion,
  AlignItems,
  Box,
  Display,
  Divider,
  Heading2,
  Heading5,
  Icon,
  Join,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'
import { useDispatch, useSelector } from 'react-redux'

import { trackUTMAndPromoCode } from 'actions/tracking'
import { RecipeSummary } from 'routes/Checkout/Components/RecipeSummary'
import { getNumPortions } from 'selectors/basket'

import { boxDetailsAccordionTexts } from '../data'
import { checkoutClickHideYourGoustoBox, checkoutClickShowYourGoustoBox } from '../trackingKeys'

function Title(isExpanded: boolean) {
  const isCollapsed = !isExpanded
  const { title } = boxDetailsAccordionTexts

  return (
    <>
      <Box
        alignItems={AlignItems.Center}
        display={Display.Flex}
        justifyContent={JustifyContent.SpaceBetween}
      >
        <Heading2 size={8}>{title}</Heading2>
        <Icon name={isExpanded ? 'chevron_up' : 'chevron_down'} />
      </Box>
      <Space size={3} />
      {isCollapsed && (
        <>
          <Space size={3} />
          <Divider />
        </>
      )}
    </>
  )
}

export function BoxDetailsAccordion() {
  const dispatch = useDispatch()

  const numPortions = useSelector(getNumPortions)
  const { recipeSummaryHeading } = boxDetailsAccordionTexts

  const sendSnowplowEventHandler = (isExpanded: boolean) => {
    dispatch(
      trackUTMAndPromoCode(
        isExpanded ? checkoutClickShowYourGoustoBox : checkoutClickHideYourGoustoBox,
      ),
    )
  }

  return (
    <Accordion
      title={Title}
      id="box-details"
      onChange={(isExpanded) => sendSnowplowEventHandler(isExpanded)}
    >
      <Join with={<Space size={4} />}>
        <Heading5>{`${recipeSummaryHeading}(${numPortions} people)`}</Heading5>
        <RecipeSummary />
        <Divider />
      </Join>
    </Accordion>
  )
}
